module.exports = __webpack_public_path__ + "img/transactions-background.90143492.svg";